import { Fragment } from 'react';

const URL_RE = /(https?:\/\/[^\s<>"']+)/g;

// Plain text with paragraphs; only http(s) URLs become links. Never renders HTML.
export function LinkifiedText({ text, className = '' }) {
  const parts = (text || '').split(URL_RE);
  return (
    <p className={`whitespace-pre-wrap break-words ${className}`}>
      {parts.map((part, i) => (i % 2 === 1 ? (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer nofollow" className="text-ruby underline break-all">{part}</a>
      ) : (
        <Fragment key={i}>{part}</Fragment>
      )))}
    </p>
  );
}
